module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/soudan_online-156c26955117d8b991aa67dbe020acfb.webp";